import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import categorieService from './categorieService';

const initialState = {
  categorie: [],
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: '',

};

// Get categorie
export const getAllCategories = createAsyncThunk(
  'categorie/get',
  async (_, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.user.token;
      return await categorieService.getAllCategories(token);
    } catch (error) {
      const message =
        (error.response?.data?.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Create categoria
export const createCategoria = createAsyncThunk(
  'categorie/create',
  async (categoriaData, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.user.token;
      return await categorieService.createCategoria(categoriaData, token);
    } catch (error) {
      const message =
        (error.response?.data?.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Update categoria
export const updateCategoria = createAsyncThunk(
  'categorie/update',
  async (categoriaData, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.user.token;
      return await categorieService.updateCategoria(categoriaData, token);
    } catch (error) {
      const message =
        (error.response?.data?.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Delete categoria (or hide it for this user, if it's a shared default)
export const deleteCategoria = createAsyncThunk(
  'categorie/delete',
  async (id, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.user.token;
      return await categorieService.deleteCategoria(id, token);
    } catch (error) {
      const message =
        (error.response?.data?.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Restore a default categoria previously hidden for this user
export const restoreCategoria = createAsyncThunk(
  'categorie/restore',
  async (id, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.user.token;
      return await categorieService.restoreCategoria(id, token);
    } catch (error) {
      const message =
        (error.response?.data?.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);


const categorieSlice = createSlice({
  name: 'categorie',
  initialState,
  reducers: {
    reset: () => ({ ...initialState }),
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllCategories.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllCategories.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.categorie = action.payload;
        state.isError = false;
        state.message = '';
      })
      .addCase(getAllCategories.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload || 'Failed to fetch categories records';
        state.categorie = [];
      })
      .addCase(createCategoria.fulfilled, (state, action) => {
        state.categorie.push(action.payload);
      })
      .addCase(updateCategoria.fulfilled, (state, action) => {
        const index = state.categorie.findIndex((cat) => cat._id === action.payload._id);
        if (index !== -1) {
          // In-place update of an owned custom categoria.
          state.categorie[index] = action.payload;
        } else {
          // Forked personal copy of a shared default categoria (new _id).
          state.categorie.push(action.payload);
        }
      })
      .addCase(deleteCategoria.fulfilled, (state, action) => {
        const { id, hidden } = action.payload;
        if (hidden) {
          const cat = state.categorie.find((c) => c._id === id);
          if (cat) cat.hiddenForUser = true;
        } else {
          state.categorie = state.categorie.filter((cat) => cat._id !== id);
        }
      })
      .addCase(restoreCategoria.fulfilled, (state, action) => {
        const cat = state.categorie.find((c) => c._id === action.payload.id);
        if (cat) cat.hiddenForUser = false;
      })
  },
});

export const { reset } = categorieSlice.actions;
export default categorieSlice.reducer;



// export const updateEvent = createAsyncThunk(
//   'match/update',
//   async (data, thunkAPI) => {
//     try {
//       const state = thunkAPI.getState();
//       const token = state.auth.user.token;
//       const eventId = data.matchId; // Assuming you pass the eventId as part of the data parameter
//       const matchData = {
//         ...data.matchData, // Assuming you pass other event data fields in eventData
//       };

//       return await budgetService.updateEvent(eventId, matchData, token);
//     } catch (error) {
//       const message =
//         (error.response &&
//           error.response.data &&
//           error.response.data.message) ||
//         error.message ||
//         error.toString();
//       return thunkAPI.rejectWithValue(message);
//     }
//   }
// );
